import React from "react";
import { useTableContext } from "../../components/AdministrateTable";
import { InNetworkPaRequiredToggle } from "./InNetworkPaRequiredToggle";

export const InNetworkPaRequiredActionCell = ({ row }) => {
  const { refresh, setMessage, setError } = useTableContext();
  const { id: cptCodeSettingId, requiresPaInNetwork } = row.original ?? {};
  const { id: payorId, name: payorName } = row.original?.payor ?? {};
  const { id: cptCodeId, code: cptCode } = row.original?.cptCode ?? {};

  const handleChange = (msg) => {
    setMessage(msg);
    refresh();
  };

  const handleError = (msg) => {
    setError(msg);
    refresh();
  };

  return (
    <InNetworkPaRequiredToggle
      payorId={payorId}
      payorName={payorName}
      requiresPaInNetwork={requiresPaInNetwork}
      cptCodeSettingId={cptCodeSettingId}
      cptCodeId={cptCodeId}
      cptCode={cptCode}
      onChange={handleChange}
      onError={handleError}
    />
  );
};
